var canOpenTopMenu = true,
    ww;

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

var seenPopup = readCookie('eauditopup');

// popup on first visit
$(window).load(function(){
  /*
  if(seenPopup === null){
    $.magnificPopup.open({
      items: {
          src: '#newsite'
      },
      type: 'inline'
    });

    createCookie('eauditopup', 1, 365);
  }
  */
});

$(function(){

  $('.lang-switch > li').click(function(){
      if($('ul', $(this)).is(':visible')){
        $('ul', $(this)).slideUp();
        $(this).removeClass('open');
      }else{
        $('ul', $(this)).slideDown();
        $(this).addClass('open');
      }
  });

  ww = $(window).width();

  // header menu
  $('#page-top nav .parent a').click(function(e){
    e.preventDefault();
    var self = $(this);
    if(canOpenTopMenu === true){
      canOpenTopMenu = false;
      var parent = self.parent();

      parent.toggleClass('open');

      parent.next('ul').slideToggle(200, function(){
        canOpenTopMenu = true;
      });
    }
  });

  $('#overlay-menu nav .parent > a').click(function(e){
    e.preventDefault();
    var self = $(this);
    if(canOpenTopMenu === true){
      canOpenTopMenu = false;
      var parent = self.parent();

      parent.toggleClass('open');

      parent.find('ul').slideToggle(200, function(){
        canOpenTopMenu = true;
      });
    }
  });

  if(!$('body').hasClass('firstpage')){
    $('.large-block svg').each(function(){
      if($(this).find('g').length == 0){
        var rect = $(this).find('rect'),
            svg = $(this),
            height = Math.round(svg.height());

            rect.attr('height', height).attr('width', svg.width());
            svg.attr('height', height).removeAttr('viewBox');
            svg[0].setAttribute('viewBox', '0 0 1081 ' + (Math.ceil(svg.height() / 10) * 10));
      }
    });
  }

  $('#contactform form').parsley();

  $('#contactform form').submit(function(e){
    e.preventDefault();

    $.ajax({
      type: 'POST',
      url: $(this).attr('action'),
      data: $(this).serialize()
    }).done(function(ret){
      if(ret == "true"){
        $("#contactform .mainform").fadeOut(300, function(){
          $('#contactform .success').fadeIn(300);
        });
      }
    });
  });

  var canClick = 1;
  $('.faq .question > a').click(function(e){
    e.preventDefault();
    if(canClick == 1){
      canClick = 0;

      var $content = $(this).next(),
          $open = $('.faq .question > a.open');
      if($open.length > 0 && $open.get(0) !== $(this).get(0)){
        $open.removeClass('open').next().slideUp(200, function(){
          $content.slideDown(400, function(){
            canClick = 1;
          });
        });
      }else{
        if($content.is(':visible')){
          $content.slideUp(400, function(){
            canClick = 1;
          });
        }else{
          $content.slideDown(400, function(){
            canClick = 1;
          });
        }
      }

      if($(this).hasClass('open')){
        $(this).removeClass('open');
      }else{
        // $('.faq .question > a.open').removeClass('open').next().slideUp(400);
        $(this).addClass('open');
      }

    }
  });
  $('button.hamburger').click(function(e){
    e.preventDefault();
    $('button.hamburger').toggleClass('is-active');
  });


  if(ww >= 1100){
    $('.back.container').each(function(){
      var width = $(this).closest('.large-block').width() - 30;
      $(this).width(width);
    });
  }else{
    $(this).width();
  }

  if(ww < 768){
    // if($('#trust-us').length && $('footer').prev().prop('id') == 'trust-us'){
    //   $('footer').css('padding-top', $('#trust-us .overlap').height()-32);
    // }
  }

  $('.button.contact, .calc').magnificPopup({
    type:'inline',
    midClick: true,
    //closeBtnInside: false
  });


  $('.calculators-head a.content-block').click(function(){
    //$('.featherlight').addClass('white');
    $('[name="salary-type"], [name="isLiving"]', $('.mfp-content')).chosen({disable_search_threshold: 10});
  });


  // Year 2018 salary calculator
  $('#calc-2018 .button').click(function(){
      calc2018('calc-2018');
  });

  // Year 2017 && 2018 salary calculator
  $('#calc-2018-3columns .button').click(function(){
      calc2018_compare();
  });


  $('.radio-switch div').click(function(){
      var calcID = $(this).parent().data('form');
      if(!$(this).hasClass('active')){
          $('#'+calcID+' .radio-switch div').removeClass('active');
          $(this).addClass('active');
          if($(this).hasClass('yes')){
              $('#'+calcID+' [name="taxbook"]').val(1);
          }else{
              $('#'+calcID+' [name="taxbook"]').val(2);
          }

          // Show / hide min and ppl fields
          if(calcID == 'calc-2018' || calcID == 'calc-2018-3columns') {
              $('#'+calcID+' .js_taxbook_hide').toggleClass('visible');
          }
      }
  });

  $('#calc-royalty input[name="button_1"]').click(function() {
      var nbun = parseFloat($('#calc-royalty #nbun').val()).toFixed(2);

      if(isNaN(nbun)) {
          nbun = 0;
      }

      var brutto_netto = $('#calc-royalty input[name="brutto_netto"]:checked').val();
      var ak = $('#calc-royalty input[name="ak"]:checked').val();

      if(brutto_netto == 'brutto') {
          switch (ak) {
              case '1':
                  ak = 0.4;
                  break;
              case '2':
                  ak = 0.3;
                  break;
              case '3':
                  ak = 0.25;
                  break;
              case '4':
                  ak = 0.2;
                  break;
              case '5':
                  ak = 0.15;
                  break;
          }

          var as = parseFloat(nbun - (nbun * ak)).toFixed(2); // apliekamā summa
          var iin = parseFloat(as * 0.23).toFixed(2);         // iedzīvotāja ienākuma nodoklis
          var netto_summa = parseFloat(nbun - iin).toFixed(2);            // uz rokas

          $('#calc-royalty #brutto_summa').text(nbun);
          $('#calc-royalty #netto_summa').text(netto_summa);
          $('#calc-royalty #aas').text(as);
          $('#calc-royalty #iin').text(iin);
      } else if(brutto_netto == 'netto') {
          switch (ak) {
              case '1':
                  ak = 0.4;
                  break;
              case '2':
                  ak = 0.3;
                  break;
              case '3':
                  ak = 0.25;
                  break;
              case '4':
                  ak = 0.2;
                  break;
              case '5':
                  ak = 0.15;
                  break;
          }

          var bruto_summa = parseFloat(nbun / (1 - ((1 - ak) * 0.23))).toFixed(2);
          $('#calc-royalty #brutto_summa').text(bruto_summa);
          $('#calc-royalty #netto_summa').text(nbun);
          $('#calc-royalty #aas').text((bruto_summa - bruto_summa * ak).toFixed(2));
          $('#calc-royalty #iin').text((bruto_summa - nbun).toFixed(2));

      }
  });



  function calc2018(targetID) {
      var nodGram = jQuery("#"+targetID+" input[name=taxbook]").val(); // nodokļu grāmatiņa

      var sumFrom = jQuery("#"+targetID+" input[name=amount]").val(); // sākuma summa
      if(sumFrom == ''){
          sumFrom = 0;
      }

      var neaplMin = jQuery("#"+targetID+" input[name=min]").val(); // Neapliekamais minimums
      if(neaplMin == ''){
          neaplMin = jQuery("#"+targetID+" input[name=min]").attr('placeholder');
      }
      if(sumFrom > 1000) { // Nepiemēro, ja alga pārsniedz 1000
          neaplMin = 0;
          jQuery("#"+targetID+" input[name=min]").val(0);
      }

      var apgadSkaits = jQuery("#"+targetID+" input[name=ppl]").val(); // Apgadājamo skaits
      if(apgadSkaits == ''){
          apgadSkaits = 0;
      }

      var dnVSAOI = 11; // Darba ņemēja VSAOI likme
      var ddVSAOI = 24.09 // Darba devēja VSAOI likme
      var dnIINa23 = 0.00; // Darba ņēmēja soc nodoklis, ja alga virs 1667 Eur
      var IIN = 20; // Iedzīvotāja ienākuma likme
      var IIN23 = 23; // Iedzīvotāja ienākuma likme, ja alga virs 1667 Eur
      var urvn = 0.36; // Uzņemējdarbības riska valsts nodeva
      var summaParApgadajamo = 200; // Summa par apgādājamo

      // Darba ņēmēja SOC
      var dnVSAOIa = parseFloat( sumFrom / 100 * dnVSAOI ).toFixed(2);
      jQuery("#"+targetID+" .js_vsaoidn").text(dnVSAOIa + " EUR");

      // Apgādājamie
      var summaParApgadamajiem = 0;
      if(nodGram == 1){
          summaParApgadamajiem = parseFloat( apgadSkaits * summaParApgadajamo ).toFixed(2);
      }

      // Apliekamais ienākums
      if(sumFrom >= 1668){
          var apliekamaSumma = 1667 - dnVSAOIa - summaParApgadamajiem;
      }else{
          var apliekamaSumma = sumFrom - dnVSAOIa - neaplMin - summaParApgadamajiem;
      }
      apliekamaSumma = apliekamaSumma < 0 ? 0 : apliekamaSumma;

      if(sumFrom >= 1668){
          var apliekamaSumma23 = sumFrom - 1667;
      }

      if(nodGram == 2){
          var apliekamaSumma23 = parseFloat( sumFrom - dnVSAOIa ).toFixed(2);
      }

      // Ienākumu nodoklis
      if(nodGram == 1){
          var dnIINa = parseFloat( apliekamaSumma / 100 * IIN ).toFixed(2);
      }else{
          var dnIINa = 0;
          var dnIINa23 = (parseFloat( sumFrom / 100 * IIN23 ) - parseFloat( (sumFrom / 100 * dnVSAOI) / 100 * IIN )).toFixed(2);
          console.log(sumFrom + ' ' + IIN23 + ' ' + dnVSAOI + ' ' + IIN);
      }
      jQuery("#"+targetID+" .js_iin").text(dnIINa + " EUR");

      // Ienākumu nodoklis 23%, ja alga virs 1667 un ir nodokļu grāmatiņa vai ja nav grāmatiņas, tad 23%
      if(sumFrom >= 1668 && nodGram == 1){
          var dnIINa23 = parseFloat( apliekamaSumma23 / 100 * IIN23 ).toFixed(2);
      }else{
          var dnIINa23 = parseFloat( dnIINa23 ).toFixed(2);
      }
      jQuery("#"+targetID+" .js_iin23").text(dnIINa23 + " EUR");

      if(nodGram == 2){
          $('#iin_20, #iin_23').removeClass('visible');
          $('#iin_23_no_taxbook').addClass('visible');
      }else{
          if(sumFrom > 1667){
              $('#iin_23').addClass('visible');
          }
          $('#iin_20').addClass('visible');
          $('#iin_23_no_taxbook').removeClass('visible');
      }

      // Riska nodeva
      jQuery("#"+targetID+" .js_risk").text(urvn + " EUR");

      // Uz rokas
      var uzRokas = parseFloat( sumFrom - dnVSAOIa - dnIINa - dnIINa23 ).toFixed(2);
      jQuery("#"+targetID+" .js_onhand").text(uzRokas + " EUR");

      // Darba devēja SOC
      var ddVSAOIa = parseFloat( sumFrom / 100 * ddVSAOI ).toFixed(2);
      jQuery("#"+targetID+" .js_vsaoidd").text(ddVSAOIa + " EUR");

      // Nodokļi kopā
      var nodokliKopa = parseFloat( sumFrom / 100 * ddVSAOI ) + parseFloat(dnVSAOIa) + parseFloat(dnIINa) + parseFloat(dnIINa23) + parseFloat(urvn);
      var ddKopa = parseFloat(sumFrom) + parseFloat( sumFrom / 100 * ddVSAOI ) + parseFloat( urvn );
      jQuery("#"+targetID+" .js_ddtotal").text(ddKopa.toFixed(2) + " EUR");

      // Show / hide notes
      if(sumFrom > 3999){
          $('#vsaoi_4000').addClass('visible');
      }else{
          $('#vsaoi_4000').removeClass('visible');
      }

      if(sumFrom > 1667 && nodGram == 1){
          $('#iin_23').addClass('visible');
      }else{
          $('#iin_23').removeClass('visible');
      }
  }

  $('#calc-2018 input[name=amount]').keyup(function(){
      if($(this).val() > 1000){
          $('#calc-2018 input#min').val(0).prop('disabled', true);
      }else{
          $('#calc-2018 input#min').val(100).prop('disabled', false);
      }
  })


  // Compare 2017 && 2018 salary
  function calc2018_compare() {
      calc2018('calc-2018-3columns');

      //Matematiskais kalkulators
      var nodGram = jQuery("#calc-2018-3columns input[name=taxbook]").val();
      var sumFrom = jQuery("#calc-2018-3columns input[name=amount]").val(); //sākuma summa
      if(sumFrom == ''){
        sumFrom = 0;
      }
      var apgadSkaits = jQuery("#calc-2018-3columns input[name=ppl]").val(); //Apgadājamo skaits
      if(apgadSkaits == ''){
          apgadSkaits = 0;
      }
      var neaplMin = jQuery("#calc-2018-3columns input[name=min]").val(); //Neapliekamais minimums
      if(neaplMin == ''){
          neaplMin = jQuery("#calc-2018-3columns input[name=min]").attr('placeholder');
      }

      var atvieglParPers = 175; //Atvieglojumi par apgādājamo
      var ddVSAOI = 23.59; //Darba devēja VSAOI likme
      var dnVSAOI = 10.5; //Darba ņemēja VSAOI likme
      var IIN = 23; //Iedzīvotāja ienākuma likme

      var urvn = 0.36; //Uzņemējdarbības riska valsts nodeva

      if (nodGram === undefined){
          nodGram = 1;
      }

      neaplMin = nodGram == 1 ? 60 : 0;
      apgadSkaits = nodGram == 1 ? apgadSkaits : 0;

      IIN = parseFloat(IIN);

      var dnIIN = (IIN / 100) * (sumFrom - (dnVSAOI/100 * sumFrom) - ((parseFloat(neaplMin) + atvieglParPers * apgadSkaits) * nodGram));
      if(dnIIN < 0){
          dnIIN = 0;
      }

      var netto = sumFrom - (dnVSAOI / 100 * sumFrom) - dnIIN;
      var NumericVal = parseFloat(netto)
      netto = NumericVal.toFixed(2);

      // VSAOI aprēķināšana darbiniekam
      var dnVSAOIa = sumFrom * dnVSAOI/100;
      var NumericDNVSAOI = parseFloat(dnVSAOIa);
      dnVSAOI = NumericDNVSAOI.toFixed(2);
      jQuery("#calc-2018-3columns .employee").text(dnVSAOI + " EUR");
      var kopaVSAOI = dnVSAOI;

      // VSAOI aprēķināšana darba devējam
      var dnVSAOIa = sumFrom * ddVSAOI/100;
      var NumericDNVSAOI = parseFloat(dnVSAOIa);
      dnVSAOI = NumericDNVSAOI.toFixed(2);
      jQuery("#calc-2018-3columns .employer").text(dnVSAOI + " EUR");

      // VSAOI aprēķins kopā
      kopaVSAOI = parseFloat(kopaVSAOI) + parseFloat(dnVSAOI + " EUR");
      var KOPSS = kopaVSAOI.toFixed(2);
      jQuery("#calc-2018-3columns .socsec").text(KOPSS);

      // Saliek visas nepieciešamās summas laukos
      var NumericIIN = parseFloat(dnIIN);
      dnIIN = NumericIIN.toFixed(2);
      jQuery("#calc-2018-3columns .iin").text(dnIIN + " EUR");
      jQuery("#calc-2018-3columns .onhand").text(netto + " EUR");
      var NumericVal2 = parseFloat(sumFrom)
      sumFrom = NumericVal2.toFixed(2);
      jQuery(".onpaper span").text(sumFrom);

      var DDS = parseFloat(sumFrom) + parseFloat(dnVSAOI) + parseFloat(urvn);
      DDS = DDS.toFixed(2);
      jQuery("#calc-2018-3columns .employertotal").text(DDS + " EUR");

      // Kopā nodokļi
      var kopa = parseFloat(kopaVSAOI) + parseFloat(dnIIN) + parseFloat(urvn);
      kopa = kopa.toFixed(2);
      jQuery("#calc-2018-3columns .totaltaxes").text(kopa + " EUR");
      jQuery("#calc-2018-3columns .risk").text(parseFloat(urvn) + " EUR");

  }


  $('#calc-salary .button').click(function(){
    //Matematiskais kalkulators
    var type = jQuery("[name=salary-type] option:selected").val(); //sākuma summa
    var nodGram = jQuery("input[name=taxbook]").val();
    var sumFrom = jQuery("input[name=amount]").val(); //sākuma summa
    if(sumFrom == ''){
      sumFrom = 0;
    }
    var apgadSkaits = jQuery("input[name=ppl]").val(); //Apgadājamo skaits
    if(apgadSkaits == ''){
        apgadSkaits = 0;
    }
    var neaplMin = jQuery("input[name=min]").val(); //Neapliekamais minimums
    if(neaplMin == ''){
        neaplMin = jQuery("input[name=min]").attr('placeholder');
    }
    var atvieglParPers = jQuery("input[name=ease]").val(); //Atvieglojumi par apgādājamo
    if(atvieglParPers == ''){
        atvieglParPers = jQuery("input[name=ease]").attr('placeholder');
    }
    var ddVSAOI = jQuery("input[name=vsaoi]").val(); //Darba devēja VSAOI likme
    if(ddVSAOI == ''){
        ddVSAOI = jQuery("input[name=vsaoi]").attr('placeholder');
    }
    var dnVSAOI = jQuery("input[name=vsaoi_empl]").val(); //Darba ņemēja VSAOI likme
    if(dnVSAOI == ''){
        dnVSAOI = jQuery("input[name=vsaoi_empl]").attr('placeholder');
    }
    var IIN = jQuery("input[name=iin]").val(); //Iedzīvotāja ienākuma likme
    if(IIN == ''){
        IIN = jQuery("input[name=iin]").attr('placeholder');
    }
    var urvn = jQuery("input[name=risk]").val(); //Uzņemējdarbības riska valsts nodeva
    if(urvn == ''){
        urvn = jQuery("input[name=risk]").attr('placeholder');
    }

    if (nodGram === undefined){
        nodGram = 1;
    }

    IIN = parseFloat(IIN);
    if (type == 1){
        var dnIIN = (IIN / 100) * (sumFrom - (dnVSAOI/100 * sumFrom) - ((parseFloat(neaplMin) + atvieglParPers * apgadSkaits) * nodGram));
        if(dnIIN < 0){
            dnIIN = 0;
        }

        var netto = sumFrom - (dnVSAOI / 100 * sumFrom) - dnIIN;
        var NumericVal = parseFloat(netto)
        netto = NumericVal.toFixed(2);


        // VSAOI aprēķināšana darbiniekam
        var dnVSAOIa = sumFrom * dnVSAOI/100;
        var NumericDNVSAOI = parseFloat(dnVSAOIa);
        dnVSAOI = NumericDNVSAOI.toFixed(2);
        jQuery(".employee span").text(dnVSAOI);
        var kopaVSAOI = dnVSAOI;

        // VSAOI aprēķināšana darba devējam
        var dnVSAOIa = sumFrom * ddVSAOI/100;
        var NumericDNVSAOI = parseFloat(dnVSAOIa);
        dnVSAOI = NumericDNVSAOI.toFixed(2);
        jQuery(".employer span").text(dnVSAOI);

        // VSAOI aprēķins kopā
        kopaVSAOI = parseFloat(kopaVSAOI) + parseFloat(dnVSAOI);
        var KOPSS = kopaVSAOI.toFixed(2);
        jQuery(".socsec span").text(KOPSS);



        //Saliek visas nepieciešamās summas laukos
        var NumericIIN = parseFloat(dnIIN);
        dnIIN = NumericIIN.toFixed(2);
        jQuery(".iin span").text(dnIIN);
        jQuery(".onhand span").text(netto);
        var NumericVal2 = parseFloat(sumFrom)
        sumFrom = NumericVal2.toFixed(2);
        jQuery(".onpaper span").text(sumFrom);

        var DDS = parseFloat(sumFrom) + parseFloat(dnVSAOI) + parseFloat(urvn);
        console.log('dds' + DDS, 'sf' + sumFrom, 'dn' + dnVSAOI, 'ur' + urvn);
        DDS = DDS.toFixed(2);
        jQuery(".employertotal span").text(DDS);

        //Kopā nodokļi
        var kopa = parseFloat(kopaVSAOI) + parseFloat(dnIIN) + parseFloat(urvn);
        kopa = kopa.toFixed(2);
        jQuery(".totaltaxes span").text(kopa);
        jQuery(".risk span").text(parseFloat(urvn));


    }else{
        //Aprēķins algai uz "rokām"

        if (parseFloat(sumFrom) <= ((parseFloat(neaplMin) + parseFloat(apgadSkaits * atvieglParPers) )* nodGram)){
            var bruto = ((4 * sumFrom) - sumFrom)*100/267;
        }else{
            // Jaunā formula priekš 23% (no 07.01.2015)
            // Aprēķinam 100 - NODOKLIS
            var dataIIN = 100-IIN;
            var dataVSAOI = 100-dnVSAOI;
            var bruto = ( (sumFrom-((parseFloat(neaplMin) + parseFloat(apgadSkaits * atvieglParPers) )* nodGram))/dataIIN*100+((parseFloat(neaplMin) + parseFloat(apgadSkaits * atvieglParPers) )* nodGram) )/dataVSAOI*100;
        }
        // IIN aprēķināšana
        var dnIIN = (IIN / 100) * (bruto - (dnVSAOI/100 * bruto) - ((parseFloat(neaplMin) + atvieglParPers * apgadSkaits) * nodGram));
        if(dnIIN < 0){
            var newDeal = dnIIN * (-1);
            dnIIN = 0;

        }

        //Netto pārrēķins
        var netto = bruto - (dnVSAOI / 100 * bruto) - dnIIN;
        var NumericVal = parseFloat(netto);
        netto = NumericVal.toFixed(2);


        // VSAOI aprēķināšana darbiniekam
        var dnVSAOIa = bruto * dnVSAOI/100;
        var NumericDNVSAOI = parseFloat(dnVSAOIa);
        dnVSAOI = NumericDNVSAOI.toFixed(2);
        jQuery(".employee span").text(dnVSAOI);
        var kopaVSAOI = dnVSAOI;

        // VSAOI aprēķināšana darba devējam
        var dnVSAOIa = bruto * ddVSAOI/100;
        var NumericDNVSAOI = parseFloat(dnVSAOIa);
        dnVSAOI = NumericDNVSAOI.toFixed(2);
        jQuery(".employer span").text(dnVSAOI);

        // VSAOI aprēķins kopā
        kopaVSAOI = parseFloat(kopaVSAOI) + parseFloat(dnVSAOI);
        var KOPSS = kopaVSAOI.toFixed(2);
        jQuery(".socsec span").text(KOPSS);


        //Saliek visas nepieciešamās summas laukos
        var NumericIIN = parseFloat(dnIIN);
        dnIIN = NumericIIN.toFixed(2);
        jQuery(".iin span").text(dnIIN);
        var NumericSumFrom = parseFloat(sumFrom)
        sumFrom = NumericSumFrom.toFixed(2);
        console.log(sumFrom);
        jQuery(".onhand span").text(netto);
        console.log(sumFrom);
        var NumericVal2 = parseFloat(netto)
        netto = NumericVal2.toFixed(2);
        jQuery(".onpaper span").text(bruto.toFixed(2));

        var DDS = parseFloat(bruto) + parseFloat(dnVSAOI) + parseFloat(urvn);
        var numericDDS = parseFloat(DDS);
        var DDS = numericDDS.toFixed(2);
        jQuery(".employertotal span").text(DDS);

        //Kopā nodokļi
        var kopa = parseFloat(kopaVSAOI) + parseFloat(dnIIN) + parseFloat(urvn);
        kopa = kopa.toFixed(2);
        jQuery(".totaltaxes span").text(kopa);

        var NumericVal = parseFloat(bruto)
        bruto = NumericVal.toFixed(2);
        jQuery(".risk span").text(parseFloat(urvn));
    }
  });


  $('#calc-property .button').click(function(){
    //kadastrovayaStoimost, isLivingQuarters, currensy

    var calc=new calculator($('#calc-property [name="value"]').val(), jQuery("#calc-property [name=isLiving] option:selected").val(), 'EUR');
		var results=calc.calculate();

    $('.value span').text(roundNumbers($('#calc-property [name="value"]').val()));
    $('.tax span').text(roundNumbers(results[results.length-1]));
    $('.pointtwo span').text(roundNumbers(results[2]));
    $('.pointfour span').text(roundNumbers(results[3]?results[3]:'0'));
    $('.pointsix span').text(roundNumbers(results[4]?results[4]:0));
    $('.onepointfive span').text(roundNumbers(results[results.length-1]));
  });

  jQuery("#calc-property [name=isLiving]").change(function(){
    if($(this).val() == 'true'){
      $('.living').show();
      $('.commercial').hide();
    }else{
      $('.living').hide();
      $('.commercial').show();
    }
  });

function hasClass(el,cls) {
	return el.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

function addClass(el,cls) {
	if (!this.hasClass(el,cls)) el.className += " "+cls;
}

function removeClass(el,cls) {
	if (hasClass(el,cls)) {
    	var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		el.className=el.className.replace(reg,' ');
	}
}
function calculator(kadastrovayaStoimost, isLivingQuarters, currensy){

	this.kadastrovayaStoimost=kadastrovayaStoimost;
	this.isLivingQuarters=(isLivingQuarters=='true');
	this.conversionCoeff=(currensy=='Ls')?1:this.EURO_TO_LAT;

	this.calculate=function(){
		var results=new Array(),
			result=0;
		if(this.kadastrovayaStoimost && !isNaN(parseFloat(this.kadastrovayaStoimost)) && isFinite(this.kadastrovayaStoimost) && this.kadastrovayaStoimost>0){
			//console.log('good number');
			if(this.isLivingQuarters){
				var first_bound=this.FIRST_BOUND_LAT/this.conversionCoeff,
					second_bound=this.SECOND_BOUND_LAT/this.conversionCoeff;
				results.push(first_bound);
				results.push(second_bound);
				var firstSummand,
				secondSummand,
				therdSummand;

				if(this.kadastrovayaStoimost <= first_bound){
					firstSummand=this.kadastrovayaStoimost*this.FIRST_BOUND_COEFF;
					secondSummand=0;
					therdSummand=0;

				} else {
					firstSummand=first_bound*this.FIRST_BOUND_COEFF;

					if(this.kadastrovayaStoimost <= second_bound){
						secondSummand=(this.kadastrovayaStoimost-first_bound)*this.SECOND_BOUND_COEFF;
						therdSummand=0;
					} else {
						secondSummand=(second_bound-first_bound)*this.SECOND_BOUND_COEFF;
						therdSummand=(this.kadastrovayaStoimost-second_bound)*this.THERD_BOUND_COEFF;
					}

				}
				results.push(firstSummand);
				results.push(secondSummand);
				results.push(therdSummand);
				results.push(firstSummand+secondSummand+therdSummand);

			} else {
				firstSummand=this.kadastrovayaStoimost*this.ALTERNATIVE_COEFF;
				results.push(firstSummand);
			}
		}
		return results;
	}
}
calculator.prototype.FIRST_BOUND_LAT=40000;
calculator.prototype.FIRST_BOUND_EUR=40000;
calculator.prototype.FIRST_BOUND_COEFF=0.002;
calculator.prototype.SECOND_BOUND_LAT=75000;
calculator.prototype.SECOND_BOUND_COEFF=0.004;
calculator.prototype.THERD_BOUND_COEFF=0.006;
calculator.prototype.ALTERNATIVE_COEFF=0.015;
calculator.prototype.EURO_TO_LAT=0.7028;

//data[0] - kadastrovaya
//data[1] - curency
//data[2] - isLiving
function getFormValues(id){
	var data= new Array();
	var form=document.getElementById(id);
	for(var i=0; i<form.elements.length-1; i++){
		data.push(form.elements[i].value);
	}
	return data
}

function startCalculations()
{
	var formId='calcForm';
	var resultsId='calc-results';
	var data=getFormValues(formId);
	var resultsTable=document.getElementById(resultsId);
	if(data)
	{
		var calc=new calculator(data[0], data[2], data[1]);
		var results=calc.calculate();
		var rows=resultsTable.getElementsByTagName('tr');
		rows[0].getElementsByTagName('th')[0].getElementsByTagName('span')[0].innerHTML=dateFormat('yyyy.mm.dd');
		if(calc.isLivingQuarters)
		{
			rows[1].getElementsByTagName('td')[1].innerHTML=roundNumbers(calc.kadastrovayaStoimost)+' '+data[1];
			rows[2].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[results.length-1])+' '+data[1];
			rows[3].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=roundBigNumbers(results[0])+' '+data[1];
			rows[3].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[2])+' '+data[1];
			rows[4].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=roundBigNumbers(results[0])+' '+data[1];
			rows[4].getElementsByTagName('td')[0].getElementsByTagName('span')[1].innerHTML=roundBigNumbers(results[1])+' '+data[1];
			rows[4].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[3]?results[3]:'0')+' '+data[1];
			rows[5].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=roundBigNumbers(results[1])+' '+data[1];
			rows[5].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[4]?results[4]:0)+' '+data[1];
		} else {

			rows[1].getElementsByTagName('td')[1].innerHTML=roundNumbers(calc.kadastrovayaStoimost)+' '+data[1];
			rows[2].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[results.length-1])+' '+data[1];
			rows[6].getElementsByTagName('td')[1].innerHTML=roundNumbers(results[results.length-1])+' '+data[1];
		}
	}
}
function roundNumbers(numb){
	return Math.round(numb*100)/100;
}
function roundBigNumbers(numb){
	return Math.round(numb/1000)*1000;
}
function changeAndClearForm(isLivingCombo){
	var templateValue= '-'
	var formId='calcForm';
	var resultsId='calc-results';
	var data=getFormValues(formId);
	var resultsTable=document.getElementById(resultsId);
	var rows=resultsTable.getElementsByTagName('tr');
	rows[1].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	rows[2].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	rows[3].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=templateValue+' '+data[1];
	rows[3].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	rows[4].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=templateValue+' '+data[1];
	rows[4].getElementsByTagName('td')[0].getElementsByTagName('span')[1].innerHTML=templateValue+' '+data[1];
	rows[4].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	rows[5].getElementsByTagName('td')[0].getElementsByTagName('span')[0].innerHTML=templateValue+' '+data[1];
	rows[5].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	rows[6].getElementsByTagName('td')[1].innerHTML=templateValue+' '+data[1];
	if(data[2]=='true'){
		removeClass(rows[3], 'not-visible');
		removeClass(rows[4], 'not-visible');
		removeClass(rows[5], 'not-visible');
		addClass(rows[6], 'not-visible');
	} else if(data[2]=='false') {
		addClass(rows[3], 'not-visible');
		addClass(rows[4], 'not-visible');
		addClass(rows[5], 'not-visible');
		removeClass(rows[6], 'not-visible');
	}

}

var pvn_pluss12

    // jQuery('[name="value"]').keyup(function() {
    //   pvn_pluss12 = jQuery(this).val().replace(/\,/g, '.');
    //   jQuery(this).val(pvn_pluss12);
    // });

    jQuery('#calc-vat .button').click(function() {
        var pvn_calc = jQuery('#calc-vat input[name="type"]:checked').val();
        var pvn_proc = parseFloat(jQuery('#calc-vat .vat-val option:selected').val()).toFixed(2);
        var summa = parseFloat(jQuery('#calc-vat [name="value"]').val()).toFixed(2);
        var pvn;
        var bez_pvn;
        var ar_pvn;
        var real_pvn;

        if(isNaN(summa)) {
            summa = 0;
        }

        switch(pvn_calc) {
            case '1':
                ar_pvn = summa;
                bez_pvn = parseFloat(summa / pvn_proc);
                pvn = parseFloat(ar_pvn - bez_pvn);

                break;
            case '2':
                bez_pvn = summa;
                ar_pvn = parseFloat(summa * pvn_proc);
                pvn = parseFloat(ar_pvn - bez_pvn);

                break;
            case '3':
                pvn = summa;
                real_pvn = (pvn_proc - 1).toFixed(2);
                bez_pvn = parseFloat(pvn / real_pvn);
                ar_pvn = parseFloat(parseFloat(pvn) + parseFloat(bez_pvn));

                break;
        }

        jQuery('.sumwith span').text(parseFloat(ar_pvn).toFixed(2));
        jQuery('.sumwithout span').text(parseFloat(bez_pvn).toFixed(2));
        jQuery('.vat-res span').text(parseFloat(pvn).toFixed(2));
    });

});

$(window).resize(function(){
  ww = $(this).width();
});

// $(document).scroll(function() {
//
// });

$(document).ready(function () {
    if(ww >= 1280){
      $(document).on("scroll", onScroll);
      $(document).scroll();
    }
    //smoothscroll
    $('.dot-menu a').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");

        $('.dot-menu a').each(function () {
            $(this).removeClass('active');
        })
        $(this).addClass('active');

        var target = this.hash,
            menu = target;
        $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top-$('#overlay-menu').height()-100
        }, 500, 'swing', function () {
            //window.location.hash = target;
            $(document).on("scroll", onScroll);
            $(document).scroll();
        });
    });
});

function onScroll(event){
    var y = $(this).scrollTop();
    if (y > $('#page-top').height() && ww >= 1100) {
      $('#overlay-menu').fadeIn(200);
    } else {
      $('#overlay-menu').fadeOut(200);
    }

    var scrollPos = $(document).scrollTop()+$('#page-top').height();
    $('.dot-menu a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top-100 <= scrollPos && refElement.position().top-100 + refElement.height() > scrollPos) {
            $('.dot-menu a').removeClass("active");
            currLink.addClass("active");
        }
        else{
            currLink.removeClass("active");
        }
    });
}

$('div[id^="calc-"] .export').click(function(e){
  e.preventDefault();

  var type      = $(this).data('type'),
      lang = $('html').attr('lang'),
      formData  = $("#calc-"+type+" input, #calc-"+type+" select")
      .filter(function(index, element) {
          return $(element).val() != "";
      })
      .serialize();

  var url = type;
  if(type == '2018'){
      url = 'salary2018';
  }
  if(type == '2018-3columns'){
      url = 'salarycompare';
  }

  var goTo = urlbase+lang+"/calc/"+url+"?"+formData;

    window.open(
      goTo,
      '_blank' // <- This is what makes it open in a new window.
    );

});
